import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';
import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation';
import { createHookWithAssistanceService, useMutation } from '@atlassian/conversation-assistant-service';
import { functionWithCondition } from '../../common/utils/function-with-condition';
import { useUIConfig } from '../../common/utils/ui-config';
import { useWindowLocation } from '../../common/utils/use-window-location';
import messages from './messages';
export var PageContextType = /*#__PURE__*/function (PageContextType) {
  PageContextType["BITBUCKET"] = "bitbucket";
  PageContextType["CONFLUENCE_HOME"] = "confluence-home";
  PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
  PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
  PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
  PageContextType["JIRA_HOME"] = "jira-home";
  PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
  PageContextType["JIRA_PROJECT"] = "jira-project";
  PageContextType["ATLAS_HOME"] = "atlas-home";
  PageContextType["UNKNOWN"] = "unknown";
  return PageContextType;
}({});
var pageTypeConversationStartersWithIssueTerm = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PageContextType.BITBUCKET, [{
  labelType: 'find-information',
  message: messages.bitbucketPrompt1
}, {
  labelType: 'get-answers',
  message: messages.bitbucketPrompt2
}, {
  labelType: 'stay-up-to-date',
  message: messages.bitbucketPrompt3
}]), PageContextType.CONFLUENCE_HOME, [{
  labelType: 'be-productive',
  message: messages.confluenceHomePrompt1
}, {
  labelType: 'stay-up-to-date',
  message: messages.confluenceHomePrompt2
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt3
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt4
}, {
  labelType: 'rephrase-content',
  message: messages.confluenceHomePrompt5
}, {
  labelType: 'draft-content',
  message: messages.confluenceHomePrompt6
}, {
  labelType: 'find-information',
  message: messages.confluenceHomePrompt7
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt8
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt9
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt10
}, {
  labelType: 'be-productive',
  message: messages.confluenceHomePrompt11
}]), PageContextType.CONFLUENCE_PAGE_VIEW, [{
  labelType: 'summarize-content',
  message: messages.confluencePageViewPrompt1
}, {
  labelType: 'summarize-content',
  message: messages.confluencePageViewPrompt2
}, {
  labelType: 'rephrase-content',
  message: messages.confluencePageViewPrompt3
}, {
  labelType: 'find-people',
  message: messages.confluencePageViewPrompt4
}, {
  labelType: 'stay-up-to-date',
  message: messages.confluencePageViewPrompt5
}, {
  labelType: 'be-productive',
  message: messages.confluencePageViewPrompt6
}]), PageContextType.CONFLUENCE_WHITEBOARD, [{
  labelType: 'summarize-content',
  message: messages.confluenceWhiteboardPrompt1
}, {
  labelType: 'get-answers',
  message: messages.confluenceWhiteboardPrompt2
}, {
  labelType: 'find-information',
  message: messages.confluenceWhiteboardPrompt3
}, {
  labelType: 'be-productive',
  message: messages.confluenceWhiteboardPrompt4
}]), PageContextType.CONFLUENCE_PAGE_EDIT, [{
  labelType: 'rephrase-content',
  message: messages.confluencePageEditPrompt1
}, {
  labelType: 'draft-content',
  message: messages.confluencePageEditPrompt2
}, {
  labelType: 'find-information',
  message: messages.confluencePageEditPrompt3
}, {
  labelType: 'be-productive',
  message: messages.confluencePageEditPrompt4
}]), PageContextType.JIRA_HOME, [{
  labelType: 'stay-up-to-date',
  message: messages.jiraHomePrompt1
}, {
  labelType: 'be-productive',
  message: messages.jiraHomePrompt2
}, {
  labelType: 'find-information',
  message: messages.jiraHomePrompt3
}, {
  labelType: 'summarize-content',
  message: messages.jiraHomePrompt4
}, {
  labelType: 'draft-content',
  message: messages.jiraHomePrompt5
}, {
  labelType: 'be-productive',
  message: messages.jiraHomePrompt6
}]), PageContextType.JIRA_ISSUE_VIEW, [{
  labelType: 'find-information',
  message: messages.jiraIssueViewPrompt1
}, {
  labelType: 'rephrase-content',
  message: messages.jiraIssueViewPrompt2
}, {
  labelType: 'draft-content',
  message: messages.jiraIssueViewPrompt3
}, {
  labelType: 'be-productive',
  message: messages.jiraIssueViewPrompt4
}]), PageContextType.JIRA_PROJECT, [{
  labelType: 'stay-up-to-date',
  message: messages.jiraProjectPrompt1
}, {
  labelType: 'be-productive',
  message: messages.jiraProjectPrompt2
}, {
  labelType: 'measure-productivity',
  message: messages.jiraProjectPrompt3
}, {
  labelType: 'find-people',
  message: messages.jiraProjectPrompt4
}, {
  labelType: 'find-people',
  message: messages.jiraProjectPrompt5
}, {
  labelType: 'be-productive',
  message: messages.jiraProjectPrompt6
}, {
  labelType: 'measure-productivity',
  message: messages.jiraProjectPrompt7
}, {
  labelType: 'find-people',
  message: messages.jiraProjectPrompt8
}, {
  labelType: 'find-information',
  message: messages.jiraProjectPrompt9
}, {
  labelType: 'get-answers',
  message: messages.jiraProjectPrompt10
}, {
  labelType: 'rephrase-content',
  message: messages.jiraProjectPrompt11
}, {
  labelType: 'summarize-content',
  message: messages.jiraProjectPrompt12
}, {
  labelType: 'draft-content',
  message: messages.jiraProjectPrompt13
}, {
  labelType: 'be-productive',
  message: messages.jiraProjectPrompt14
}]), PageContextType.ATLAS_HOME, [{
  labelType: 'find-information',
  message: messages.atlasHomePrompt1
}, {
  labelType: 'measure-productivity',
  message: messages.atlasHomePrompt2
}, {
  labelType: 'get-answers',
  message: messages.atlasHomePrompt3
}, {
  labelType: 'draft-content',
  message: messages.atlasHomePrompt4
}, {
  labelType: 'be-productive',
  message: messages.atlasHomePrompt5
}, {
  labelType: 'draft-content',
  message: messages.atlasHomePrompt6
}, {
  labelType: 'be-productive',
  message: messages.confluenceHomePrompt1
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt4
}, {
  labelType: 'rephrase-content',
  message: messages.confluenceHomePrompt5
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt11
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt8
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt10
}, {
  labelType: 'stay-up-to-date',
  message: messages.jiraHomePrompt2
}, {
  labelType: 'find-information',
  message: messages.jiraHomePrompt3
}, {
  labelType: 'summarize-content',
  message: messages.jiraHomePrompt4
}, {
  labelType: 'be-productive',
  message: messages.atlasHomePrompt7
}]), PageContextType.UNKNOWN, [{
  labelType: 'find-information',
  message: messages.unknownPrompt1
}, {
  labelType: 'be-productive',
  message: messages.unknownPrompt2
}, {
  labelType: 'draft-content',
  message: messages.unknownPrompt3
}]);
var pageTypeConversationStarters = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PageContextType.BITBUCKET, [{
  labelType: 'find-information',
  message: messages.bitbucketPrompt1
}, {
  labelType: 'get-answers',
  message: messages.bitbucketPrompt2
}, {
  labelType: 'stay-up-to-date',
  message: messages.bitbucketPrompt3
}]), PageContextType.CONFLUENCE_HOME, [{
  labelType: 'be-productive',
  message: messages.confluenceHomePrompt1
}, {
  labelType: 'stay-up-to-date',
  message: messages.confluenceHomePrompt2
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt3
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt4
}, {
  labelType: 'rephrase-content',
  message: messages.confluenceHomePrompt5
}, {
  labelType: 'draft-content',
  message: messages.confluenceHomePrompt6
}, {
  labelType: 'find-information',
  message: messages.confluenceHomePrompt7
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt8
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt9
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt10
}, {
  labelType: 'be-productive',
  message: messages.confluenceHomePrompt11
}]), PageContextType.CONFLUENCE_PAGE_VIEW, [{
  labelType: 'summarize-content',
  message: messages.confluencePageViewPrompt1
}, {
  labelType: 'summarize-content',
  message: messages.confluencePageViewPrompt2
}, {
  labelType: 'rephrase-content',
  message: messages.confluencePageViewPrompt3
}, {
  labelType: 'find-people',
  message: messages.confluencePageViewPrompt4
}, {
  labelType: 'stay-up-to-date',
  message: messages.confluencePageViewPrompt5
}, {
  labelType: 'be-productive',
  message: messages.confluencePageViewPrompt6
}]), PageContextType.CONFLUENCE_WHITEBOARD, [{
  labelType: 'summarize-content',
  message: messages.confluenceWhiteboardPrompt1
}, {
  labelType: 'get-answers',
  message: messages.confluenceWhiteboardPrompt2
}, {
  labelType: 'find-information',
  message: messages.confluenceWhiteboardPrompt3
}, {
  labelType: 'be-productive',
  message: messages.confluenceWhiteboardPrompt4
}]), PageContextType.CONFLUENCE_PAGE_EDIT, [{
  labelType: 'rephrase-content',
  message: messages.confluencePageEditPrompt1
}, {
  labelType: 'draft-content',
  message: messages.confluencePageEditPrompt2
}, {
  labelType: 'find-information',
  message: messages.confluencePageEditPrompt3
}, {
  labelType: 'be-productive',
  message: messages.confluencePageEditPrompt4
}]), PageContextType.JIRA_HOME, [{
  labelType: 'stay-up-to-date',
  message: messages.jiraHomePrompt1IssueTermRefresh
}, {
  labelType: 'be-productive',
  message: messages.jiraHomePrompt2IssueTermRefresh
}, {
  labelType: 'find-information',
  message: messages.jiraHomePrompt3IssueTermRefresh
}, {
  labelType: 'summarize-content',
  message: messages.jiraHomePrompt4IssueTermRefresh
}, {
  labelType: 'draft-content',
  message: messages.jiraHomePrompt5
}, {
  labelType: 'be-productive',
  message: messages.jiraHomePrompt6
}]), PageContextType.JIRA_ISSUE_VIEW, [{
  labelType: 'find-information',
  message: messages.jiraIssueViewPrompt1IssueTermRefresh
}, {
  labelType: 'rephrase-content',
  message: messages.jiraIssueViewPrompt2
}, {
  labelType: 'draft-content',
  message: messages.jiraIssueViewPrompt3IssueTermRefresh
}, {
  labelType: 'be-productive',
  message: messages.jiraIssueViewPrompt4
}]), PageContextType.JIRA_PROJECT, [{
  labelType: 'stay-up-to-date',
  message: messages.jiraProjectPrompt1
}, {
  labelType: 'be-productive',
  message: messages.jiraProjectPrompt2IssueTermRefresh
}, {
  labelType: 'measure-productivity',
  message: messages.jiraProjectPrompt3IssueTermRefresh
}, {
  labelType: 'find-people',
  message: messages.jiraProjectPrompt4IssueTermRefresh
}, {
  labelType: 'find-people',
  message: messages.jiraProjectPrompt5IssueTermRefresh
}, {
  labelType: 'be-productive',
  message: messages.jiraProjectPrompt6IssueTermRefresh
}, {
  labelType: 'measure-productivity',
  message: messages.jiraProjectPrompt7IssueTermRefresh
}, {
  labelType: 'find-people',
  message: messages.jiraProjectPrompt8
}, {
  labelType: 'find-information',
  message: messages.jiraProjectPrompt9IssueTermRefresh
}, {
  labelType: 'get-answers',
  message: messages.jiraProjectPrompt10IssueTermRefresh
}, {
  labelType: 'rephrase-content',
  message: messages.jiraProjectPrompt11IssueTermRefresh
}, {
  labelType: 'summarize-content',
  message: messages.jiraProjectPrompt12IssueTermRefresh
}, {
  labelType: 'draft-content',
  message: messages.jiraProjectPrompt13IssueTermRefresh
}, {
  labelType: 'be-productive',
  message: messages.jiraProjectPrompt14
}]), PageContextType.ATLAS_HOME, [{
  labelType: 'find-information',
  message: messages.atlasHomePrompt1
}, {
  labelType: 'measure-productivity',
  message: messages.atlasHomePrompt2
}, {
  labelType: 'get-answers',
  message: messages.atlasHomePrompt3
}, {
  labelType: 'draft-content',
  message: messages.atlasHomePrompt4
}, {
  labelType: 'be-productive',
  message: messages.atlasHomePrompt5
}, {
  labelType: 'draft-content',
  message: messages.atlasHomePrompt6
}, {
  labelType: 'be-productive',
  message: messages.confluenceHomePrompt1
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt4
}, {
  labelType: 'rephrase-content',
  message: messages.confluenceHomePrompt5
}, {
  labelType: 'summarize-content',
  message: messages.confluenceHomePrompt11
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt8
}, {
  labelType: 'find-people',
  message: messages.confluenceHomePrompt10
}, {
  labelType: 'stay-up-to-date',
  message: messages.jiraHomePrompt2IssueTermRefresh
}, {
  labelType: 'find-information',
  message: messages.jiraHomePrompt3IssueTermRefresh
}, {
  labelType: 'summarize-content',
  message: messages.jiraHomePrompt4IssueTermRefresh
}, {
  labelType: 'be-productive',
  message: messages.atlasHomePrompt7
}]), PageContextType.UNKNOWN, [{
  labelType: 'find-information',
  message: messages.unknownPrompt1
}, {
  labelType: 'be-productive',
  message: messages.unknownPrompt2
}, {
  labelType: 'draft-content',
  message: messages.unknownPrompt3
}]);
var getPageTypeConversationStarters = functionWithCondition(function () {
  return fg('confluence-issue-terminology-refresh');
}, function () {
  return pageTypeConversationStarters;
}, function () {
  return pageTypeConversationStartersWithIssueTerm;
});
var PAGE_TYPE_CONVERSATION_STARTERS = getPageTypeConversationStarters();
var llmPageTypeLablesWithIssueTerm = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PageContextType.CONFLUENCE_HOME, [{
  message: messages.confluenceHomeLLMLabel1
}, {
  message: messages.confluenceHomeLLMLabel2
}, {
  message: messages.confluenceHomeLLMLabel3
}]), PageContextType.CONFLUENCE_PAGE_VIEW, [{
  message: messages.confluencePageLLMLabel1
}, {
  message: messages.confluencePageLLMLabel2
}, {
  message: messages.confluencePageLLMLabel3
}, {
  message: messages.confluencePageLLMLabel4
}]), PageContextType.CONFLUENCE_WHITEBOARD, [{
  message: messages.confluenceWhiteboardLLMLabel1
}, {
  message: messages.confluenceWhiteboardLLMLabel2
}, {
  message: messages.confluenceWhiteboardLLMLabel3
}]), PageContextType.CONFLUENCE_PAGE_EDIT, [{
  message: messages.confluencePageLLMLabel1
}, {
  message: messages.confluencePageLLMLabel2
}, {
  message: messages.confluencePageLLMLabel3
}, {
  message: messages.confluencePageLLMLabel4
}]), PageContextType.JIRA_HOME, [{
  message: messages.jiraProjectLLMLabel1
}, {
  message: messages.jiraProjectLLMLabel2
}, {
  message: messages.jiraProjectLLMLabel3
}, {
  message: messages.jiraProjectLLMLabel4
}]), PageContextType.JIRA_ISSUE_VIEW, [{
  message: messages.jiraIssueLLMLabel1
}, {
  message: messages.jiraIssueLLMLabel2
}, {
  message: messages.jiraIssueLLMLabel3
}, {
  message: messages.jiraIssueLLMLabel4
}]), PageContextType.JIRA_PROJECT, [{
  message: messages.jiraProjectLLMLabel1
}, {
  message: messages.jiraProjectLLMLabel2
}, {
  message: messages.jiraProjectLLMLabel3
}, {
  message: messages.jiraProjectLLMLabel4
}]), PageContextType.UNKNOWN, [{
  message: messages.unknownLLMLabel1
}]);
var llmPageTypeLables = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PageContextType.CONFLUENCE_HOME, [{
  message: messages.confluenceHomeLLMLabel1
}, {
  message: messages.confluenceHomeLLMLabel2
}, {
  message: messages.confluenceHomeLLMLabel3
}]), PageContextType.CONFLUENCE_PAGE_VIEW, [{
  message: messages.confluencePageLLMLabel1
}, {
  message: messages.confluencePageLLMLabel2
}, {
  message: messages.confluencePageLLMLabel3
}, {
  message: messages.confluencePageLLMLabel4
}]), PageContextType.CONFLUENCE_WHITEBOARD, [{
  message: messages.confluenceWhiteboardLLMLabel1
}, {
  message: messages.confluenceWhiteboardLLMLabel2
}, {
  message: messages.confluenceWhiteboardLLMLabel3
}]), PageContextType.CONFLUENCE_PAGE_EDIT, [{
  message: messages.confluencePageLLMLabel1
}, {
  message: messages.confluencePageLLMLabel2
}, {
  message: messages.confluencePageLLMLabel3
}, {
  message: messages.confluencePageLLMLabel4
}]), PageContextType.JIRA_HOME, [{
  message: messages.jiraProjectLLMLabel1
}, {
  message: messages.jiraProjectLLMLabel2
}, {
  message: messages.jiraProjectLLMLabel3
}, {
  message: messages.jiraProjectLLMLabel4
}]), PageContextType.JIRA_ISSUE_VIEW, [{
  message: messages.jiraIssueLLMLabel1IssueTermRefresh
}, {
  message: messages.jiraIssueLLMLabel2IssueTermRefresh
}, {
  message: messages.jiraIssueLLMLabel3IssueTermRefresh
}, {
  message: messages.jiraIssueLLMLabel4IssueTermRefresh
}]), PageContextType.JIRA_PROJECT, [{
  message: messages.jiraProjectLLMLabel1
}, {
  message: messages.jiraProjectLLMLabel2
}, {
  message: messages.jiraProjectLLMLabel3
}, {
  message: messages.jiraProjectLLMLabel4
}]), PageContextType.UNKNOWN, [{
  message: messages.unknownLLMLabel1
}]);
var getLlmPageTypeLabels = functionWithCondition(function () {
  return fg('confluence-issue-terminology-refresh');
}, function () {
  return llmPageTypeLables;
}, function () {
  return llmPageTypeLablesWithIssueTerm;
});
export var LLM_PAGE_TYPE_LABELS = getLlmPageTypeLabels();
export var determinePageType = function determinePageType(location) {
  var urlPatterns = [[PageContextType.BITBUCKET, /bitbucket\.org\/.*/], [PageContextType.CONFLUENCE_HOME, /\/wiki\/home$/], [PageContextType.CONFLUENCE_PAGE_EDIT, /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\/edit-v2\//], [PageContextType.CONFLUENCE_PAGE_VIEW, /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\//], [PageContextType.CONFLUENCE_WHITEBOARD, /\/wiki\/spaces\/[^\/]+\/whiteboard\//], [PageContextType.JIRA_ISSUE_VIEW, /\/browse\/[^\/]+$/], [PageContextType.JIRA_ISSUE_VIEW, /\/jira\/.+\/projects\/.+\?selectedIssue/], [PageContextType.JIRA_PROJECT, /\/jira\/.+\/projects\//], [PageContextType.JIRA_HOME, /\/jira\/dashboards\/last-visited$/],
  // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
  [PageContextType.ATLAS_HOME, /\/(home|team)\./]];
  for (var _i = 0, _urlPatterns = urlPatterns; _i < _urlPatterns.length; _i++) {
    var _urlPatterns$_i = _slicedToArray(_urlPatterns[_i], 2),
      type = _urlPatterns$_i[0],
      pattern = _urlPatterns$_i[1];
    var matched = pattern.test(location);
    if (!matched) {
      continue;
    }
    if (type === PageContextType.CONFLUENCE_WHITEBOARD) {
      var isExperimentEnable = FeatureGates.getExperimentValue('contextual_conversation_starters_for_whiteboards', 'enable', false);
      return isExperimentEnable ? type : PageContextType.UNKNOWN;
    }
    return type;
  }
  return PageContextType.UNKNOWN;
};
export var usePageContextType = function usePageContextType() {
  var location = useWindowLocation();
  var _useState = useState(determinePageType(location)),
    _useState2 = _slicedToArray(_useState, 2),
    pageContextType = _useState2[0],
    setPageContextType = _useState2[1];
  useEffect(function () {
    setPageContextType(determinePageType(location));
  }, [location]);
  return pageContextType;
};
var shuffleArray = function shuffleArray(arr) {
  // Shuffle array using Fisher-Yates algorithm
  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [arr[j], arr[i]];
    arr[i] = _ref[0];
    arr[j] = _ref[1];
  }
  return arr;
};
var getRandomStarters = function getRandomStarters(starters, num) {
  // Return the first `num` items
  return shuffleArray(starters).slice(0, num);
};
export var llmGeneratedConvoStartersPageTypeAllowList = [PageContextType.CONFLUENCE_PAGE_VIEW, PageContextType.CONFLUENCE_PAGE_EDIT, PageContextType.CONFLUENCE_WHITEBOARD, PageContextType.JIRA_ISSUE_VIEW];
var getConversationStarterLimit = function getConversationStarterLimit(isFullscreen) {
  return isFullscreen ? 6 : 3;
};
export var useGetLLMLabelWithoutRepeat = function useGetLLMLabelWithoutRepeat(pageContextType) {
  /**
   * To avoid repetition, this function shuffles the labels array
   * and for every function call, it always get the next one in the shuffled array.
   *
   * Using `useMemo`, this function will reset the labelsShuffled when pageContextType changes.
   * so it will always randomise the correct labels for the current pageContextType.
   */
  var getLLMLabel = useMemo(function () {
    var labelsByPageType = LLM_PAGE_TYPE_LABELS[pageContextType];
    if (!labelsByPageType) {
      return function () {
        return {
          labelText: undefined,
          currentLabelIndex: -1
        };
      };
    }
    var shuffledLabels = shuffleArray(labelsByPageType);
    var labelIndex = 0;
    return function () {
      var currentLabelIndex = labelIndex;
      var labelText = shuffledLabels[labelIndex];
      // make sure the index loops back to the beginning of the array
      labelIndex = (labelIndex + 1) % shuffledLabels.length;
      return {
        labelText: labelText,
        currentLabelIndex: currentLabelIndex
      };
    };
  }, [pageContextType]);
  return {
    getLLMLabel: getLLMLabel
  };
};
export var useContextualConversationStarters = createHookWithAssistanceService(function (_ref2) {
  var _ref2$assistanceServi = _ref2.assistanceServiceInjectedParams,
    assistanceService = _ref2$assistanceServi.assistanceService,
    experienceTracker = _ref2$assistanceServi.experienceTracker,
    _onError = _ref2.onError,
    _onSuccess = _ref2.onSuccess,
    onInit = _ref2.onInit;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var pageContextType = usePageContextType();
  var _useUIConfig = useUIConfig(),
    fullScreen = _useUIConfig.fullScreen;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    didTimeOut = _useState4[0],
    setDidTimeOut = _useState4[1];
  var _useState5 = useState(new Array(3).fill(null)),
    _useState6 = _slicedToArray(_useState5, 2),
    starters = _useState6[0],
    setStarters = _useState6[1];
  var timeoutRef = useRef(null);
  var cancelTimeout = useCallback(function () {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);
  var staticContextualConversationStarters = useMemo(function () {
    var contextualStarters = PAGE_TYPE_CONVERSATION_STARTERS[pageContextType].map(function (starter) {
      return {
        labelType: starter.labelType,
        message: formatMessage(starter.message),
        type: 'static'
      };
    });
    var conversationStarterLimit = getConversationStarterLimit(fullScreen !== null && fullScreen !== void 0 ? fullScreen : false);

    // We don't need to shuffle the starters when the page context type is unknown
    var staticContextualStarters = pageContextType === PageContextType.UNKNOWN ? contextualStarters.slice(0, conversationStarterLimit) : getRandomStarters(contextualStarters, conversationStarterLimit);
    return staticContextualStarters;
  }, [pageContextType, fullScreen, formatMessage]);
  var _useGetLLMLabelWithou = useGetLLMLabelWithoutRepeat(pageContextType),
    getLLMLabel = _useGetLLMLabelWithou.getLLMLabel;
  var _useMutation = useMutation({
      mutationFn: function () {
        var _mutationFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
          var fallbackStarters, _ref3$userDefinedStar, userDefinedStarters, browser_url;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                fallbackStarters = _ref3.fallbackStarters, _ref3$userDefinedStar = _ref3.userDefinedStarters, userDefinedStarters = _ref3$userDefinedStar === void 0 ? [] : _ref3$userDefinedStar, browser_url = _ref3.locationUrl;
                onInit === null || onInit === void 0 || onInit();
                experienceTracker.start({
                  id: ExperienceName.FETCH_CONTEXTUAL_STARTERS,
                  name: ExperienceName.FETCH_CONTEXTUAL_STARTERS
                });
                setDidTimeOut(false);
                setStarters([].concat(_toConsumableArray(userDefinedStarters), _toConsumableArray(fallbackStarters.slice(0, 1)), _toConsumableArray(new Array(3).fill(null))).slice(0, 3));
                beginTimeout(userDefinedStarters, fallbackStarters);
                _context.next = 8;
                return assistanceService.generateContextualStarters({
                  browser_url: browser_url
                });
              case 8:
                return _context.abrupt("return", _context.sent);
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function mutationFn(_x) {
          return _mutationFn.apply(this, arguments);
        }
        return mutationFn;
      }(),
      onSuccess: function () {
        var _onSuccess2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(responseData) {
          var updatedStarters;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _onSuccess === null || _onSuccess === void 0 || _onSuccess();
                experienceTracker.succeed({
                  name: ExperienceName.FETCH_CONTEXTUAL_STARTERS
                });
                updatedStarters = _toConsumableArray(starters);
                if (!didTimeOut) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return");
              case 5:
                cancelTimeout();
                responseData === null || responseData === void 0 || responseData.conversation_starters.map(function (_ref4) {
                  var responseStarter = _ref4.text;
                  var index = updatedStarters.indexOf(null);
                  var starterAlreadyExists = updatedStarters.some(function (starter) {
                    return (starter === null || starter === void 0 ? void 0 : starter.message) === responseStarter;
                  });

                  // If there is a null value in the starters array AND the new starter we get from the backend
                  // does not already exist in the array, replace the null value with the new starter
                  if (index !== -1 && !starterAlreadyExists) {
                    updatedStarters[index] = {
                      message: responseStarter,
                      type: 'llm-generated',
                      labelType: 'llm-generated',
                      llmLabel: getLLMLabel().labelText
                    };
                    setStarters(updatedStarters);
                  }
                });
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function onSuccess(_x2) {
          return _onSuccess2.apply(this, arguments);
        }
        return onSuccess;
      }(),
      onError: function onError(error) {
        _onError === null || _onError === void 0 || _onError(error);
        experienceTracker.fail({
          name: ExperienceName.FETCH_CONTEXTUAL_STARTERS,
          error: error
        });
      }
    }),
    getDynamicContextualStarters = _useMutation.mutate,
    error = _useMutation.error,
    isSubmitting = _useMutation.isSubmitting;
  var beginTimeout = useCallback(function (userDefinedStarters, fallbackStarters) {
    timeoutRef.current = window.setTimeout(function () {
      experienceTracker.abort({
        name: ExperienceName.FETCH_CONTEXTUAL_STARTERS,
        reason: 'timeout'
      });
      setDidTimeOut(true);
      setStarters([].concat(_toConsumableArray(userDefinedStarters), _toConsumableArray(fallbackStarters)).slice(0, 3));
    }, 2000);
    return cancelTimeout;
  }, [cancelTimeout, experienceTracker]);
  return {
    getDynamicContextualStarters: getDynamicContextualStarters,
    starters: starters,
    error: error,
    // TODO - Implement appropriate request abort logic for useMutation, much like useStreamingMutation has, this is a stop gap
    isMutating: didTimeOut ? false : isSubmitting,
    staticContextualConversationStarters: staticContextualConversationStarters,
    cancelTimeout: cancelTimeout
  };
});